import { VimCoreLegacyWidgetsType } from './interface';

export const LEGACY_WIDGETS_GLOBAL_VARIABLE: Record<VimCoreLegacyWidgetsType, string> = {
  vimboxWidgets: 'sky-widgets',
  motivationWidgets: 'motivation-widgets',
};
